import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export enum InsuranceCoverProvider {
    Allianz = 'allianz',
    Atradius = 'atradius',
}

export const AllianzProcessPayloadSchema = z.object({
    coverAmount: z.number().optional(),
    insuranceCoverProvider: z.enum([InsuranceCoverProvider.Allianz, InsuranceCoverProvider.Atradius]).optional(),
});

export class AllianzProcessPayload extends FromSchema(AllianzProcessPayloadSchema) {
    coverAmount?: number;
    insuranceCoverProvider?: InsuranceCoverProvider;
}
